/*
 * Quiz V4 section order
 * Basics
 * 1 - Hormones (hormone/hormones-men)
 * 2 - Stress
 * 3 - Lifestyle (old Environment)
 * 4 - Metabolism
 * 5 - Nutrition
 * 6 - Aging
 * Save Results
 * Results
 */

export const moreQuestions = (currentStep, totalSteps) => {
  return currentStep < totalSteps
}

export const getNextSection = (currentSection, gender, age) => {

  if (!!currentSection) {
    if (currentSection === "basics") {
      return !!gender && gender.globalid === "men"
        ? "hormones-men"
        : "hormone"
    } else if (
      currentSection === "hormones-men" ||
      currentSection === "hormone"
    ) {
      return "stress"
    } else if (currentSection === "stress") {
      return "lifestyle"
    } else if (currentSection === "lifestyle") {
      return "metabolism"
    } else if (currentSection === "metabolism") {
      return "nutrition"
    } else if (currentSection === "nutrition") {
      return "aging"
    } else if (currentSection === "aging") {
      return "save-results"
    } else if (currentSection === "save-results") {
      return "results"
    } else if (currentSection === "intro") {
      return "basics"
    }
  }

  return "basics"
}

export const getPreviousSection = (currentSection, gender) => {

  if (!!currentSection) {
    if (currentSection === "results") {
      return "aging"
    } else if (currentSection === "aging") {
      return "nutrition"
    } else if (currentSection === "nutrition") {
      return "metabolism"
    } else if (currentSection === "metabolism") {
      return "lifestyle"
    } else if (currentSection === "lifestyle") {
      return "stress"
    } else if (currentSection === "stress") {
      return !!gender && gender.globalid === "men"
        ? "hormones-men"
        : "hormone"
    } else if (currentSection === "basics") {
      return "intro"
    }
    return "basics"
  }

  return "basics"
}
